import queryString from "query-string";

import { init as initSimulacao } from "./simulacao";
import { fetchWrapper } from "../utils/fetch";

export const init = async () => {
    const requestParameters = queryString.parse(window.location.search);
    const rsid = requestParameters.RSID;
    const customer = requestParameters.customer;

    if (rsid) {
        const response = await fetchWrapper(
            `/api/security/login?rsid=${rsid}&customer=${customer}`, 
            null, 
            {
                usingModularAuthentication: false
            })

        if (response) 
            window.location.replace("/");
    }
    else {
        //carrega simulação e outras telas
        await initSimulacao();
    }
}